import { create } from "zustand";

const useSessionStore = create(
    (set) => ({
      user: undefined,
      //devices: null,
      //dashboards: null,
      setUser: (newUser) => set({ user: newUser }),
      //setDevices: (newDevices) => set({ devices: newDevices }),
      //setDashboards: (newDashboards) => set({ dashboards: newDashboards }),
      clear: () => {
        set({ user: null });
        //set({ devices: null });
        //set({ dashboards: null });
      }
    }),
);

export default useSessionStore;
